import actions from "./applications-list-actions";
import getters from "./applications-list-getters";
import mutations from "./applications-list-mutations";
import state from "./applications-list-state";
const ApplicationsListStore = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
export default ApplicationsListStore;